// Create a simple Vue plugin to expose the wrapper object throughout the application

export const Paddle = {
    getInstance() {
        return window.Paddle
    },
    install(Vue, {sandbox, vendor}) {
        if (sandbox) window.Paddle.Environment.set('sandbox');

        window.Paddle.Setup({vendor});

        Vue.prototype.$paddle = window.Paddle
    }
};
